import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import './styles/notification.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
  content: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  },
  linkText: {
    type: String,
    default: ''
  },
  linkLabel: {
    type: String,
    default: ''
  },
  link: {
    type: String,
    default: ''
  },
  isNotificationOpen: {
    type: Boolean,
    default: false
  }
},
  emits: ['notificationClosed'],
  setup(__props, { emit }) {

const props = __props;





const isOpen = ref(false); // TODO: If Vue 3.4 or above, to be replaced by defineModels

const notificationTimeoutDuration = ref(8000);

let notificationTimeout = setTimeout(() => { isOpen.value = false; }, notificationTimeoutDuration.value);

const capitalize = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

function handleNotificationHover() {
  clearTimeout(notificationTimeout);
}

function handleNotificationLeave() {
  notificationTimeout = setTimeout(() => {
    isOpen.value = false;
  }, notificationTimeoutDuration.value);
}

function closeNotification() {
  clearTimeout(notificationTimeout);
  isOpen.value = false;
}

watch(
  () => props.isNotificationOpen,
  () => {
    clearTimeout(notificationTimeout);
    isOpen.value = props.isNotificationOpen;
    notificationTimeout = setTimeout(() => {
      isOpen.value = false;
    }, notificationTimeoutDuration.value);
  }
);

watch(
  isOpen,
  () => {
    if (!isOpen.value) {
      emit('notificationClosed');
    }
  }
);

return { __sfc: true,props, emit, isOpen, notificationTimeoutDuration, notificationTimeout, capitalize, handleNotificationHover, handleNotificationLeave, closeNotification }
}

})